import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import { withNamespaces } from 'react-i18next';
import { Row, Col, Form } from "react-bootstrap";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import hr from 'date-fns/locale/hr';
import TransactionsByCountry from './TransactionsByCountry';
import GetTotalAmount from '../../../API/Provider/GetTotalAmount';
import GetNumberOftransactionsByCountry from '../../../API/Provider/GetNumberOftransactionsByCountry';
import GetAmount from '../../../API/Provider/GetAmount'
import GetAmountByCountry from '../../../API/Provider/GetAmountByCountry'
import Loader from './../../../Global/loader'
import GetAmountByPaymentType from '../../../API/Provider/GetAmountByPaymentType';
import TransactionsByPaymentType from './TransactionsByPaymentType';
import AmountByCountry from './AmountByCountry';
import Total from './Total'
import TotalByCountry from './TotalByCountry'

export class Main extends React.Component{
    constructor(props) {
        super(props);
       
        this.state={
            loading: true,
        } 
    }

    componentDidMount = async () => {
        const { t } = this.props        
        document.title=t('Dashboard')
        
        this.search()
    }

    search = async () => {
        await this.setState({loading: true})

        const numberOfTransactions = await GetTotalAmount(
            this.props.fromDate,
            this.props.toDate
        )

        await this.props.mapState("MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS", numberOfTransactions.data.data) 

        const numberOfTransactionsByCountry = await GetNumberOftransactionsByCountry(
            this.props.fromDate,
            this.props.toDate
        )

        await this.props.mapState("MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS_BY_COUNTRY", numberOfTransactionsByCountry.data.data)

        const numberOfTransactionsByPaymentType = await GetAmountByPaymentType(
            this.props.fromDate,
            this.props.toDate
        )

        await this.props.mapState("MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS_BY_PAYMENT_TYPE", numberOfTransactionsByPaymentType.data.data)

        const amount = await GetAmount(
            this.props.fromDate,
            this.props.toDate
        )

        await this.props.mapState("MAP_DASHBOARD_AMOUNT", amount.data.data)

        const amountByCountry = await GetAmountByCountry(
            this.props.fromDate,
            this.props.toDate
        )

        await this.props.mapState("MAP_DASHBOARD_AMOUNT_BY_COUNTRY", amountByCountry.data.data)


        await this.setState({loading: false})
    }

    handleDateChange = async (e, field) => {
        e = e == null ? "" : e
        var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        var localISOTime = (new Date(e - tzoffset)).toISOString();
        if(field === "fromDate"){
            await this.props.mapState("MAP_DASHBOARD_FROM_DATE", e === "" ? "" : localISOTime) 
        }
        else{
            await this.props.mapState("MAP_DASHBOARD_TO_DATE", e === "" ? "" : localISOTime) 
        } 
        
        this.componentDidMount()
    }
    

    render(){  
        const { t } = this.props
      
        return(
            <main className="scrollbar-hidden">  
                <header>
                    <Row>
                       <Form.Group as={Row} className="mb-3">   
                            <Col sm="6" xl="3">
                                <h2>
                                    {t('Dashboard')}
                                </h2>
                                <hr/>
                            </Col>
                        </Form.Group>
                    </Row>
                </header>  

                <Row className="">                    
                    <Col sm={12} lg={3} xl={2} xxl={1}>
                       <Form.Group as={Row} className="mb-3">
                           <Col sm={12}>
                                <DatePicker
                                    selected={this.props.fromDate !== ""  ? new Date(this.props.fromDate) : ""}
                                    onChange={date => this.handleDateChange(date, "fromDate")}
                                    startDate={new Date()}
                                    locale={this.props.lng === "hr" ? hr : null}
                                    dateFormat="dd.MM.yyyy"
                                    maxDate={this.props.toDate === "" ? new Date() : new Date(this.props.toDate)}
                                    className="date-picker"
                                />                                 
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={12} lg={3} xl={2} xxl={1}>
                       <Form.Group as={Row} className="mb-3">
                           <Col sm={12}>
                                <DatePicker
                                    selected={this.props.toDate !== ""  ? new Date(this.props.toDate) : ""}
                                    onChange={date => this.handleDateChange(date, "toDate")}
                                    minDate={this.props.fromDate === "" ? "" : new Date(this.props.fromDate)}
                                    locale={this.props.lng === "hr" ? hr : null}
                                    dateFormat="dd.MM.yyyy"
                                    maxDate={new Date()}
                                    className="date-picker"
                                />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            {this.state.loading ?
                <Loader />
            :
                <div className="mt-4">
                    <Row>
                        <Col>
                            <TransactionsByCountry />
                        </Col>
                        <Col>
                            <TransactionsByPaymentType />
                        </Col>
                        <Col>
                            <AmountByCountry />
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col className="text-align-webkit-center">
                            <Total />
                        </Col>

                        <Col className="text-align-webkit-center">
                            <TotalByCountry />
                        </Col>
                    
                    </Row>
                </div>
            }
        </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        fromDate: state.dashboard.fromDate,
        toDate: state.dashboard.toDate
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(Main));
